import type { ComboboxOption } from "@/components/ui/combobox-select";

type CustomerComboboxUser = {
  _id: string;
  company?: string | null;
  name?: string | null;
  fullName?: string | null;
  email?: string | null;
};

function getTrimmedValue(value?: string | null): string {
  return String(value ?? "").trim();
}

export function getCustomerDisplayLabel(user: CustomerComboboxUser | null | undefined): string {
  const company = getTrimmedValue(user?.company);
  const name = getTrimmedValue(user?.fullName ?? user?.name);
  const email = getTrimmedValue(user?.email);

  return company || name || email;
}

function getCustomerDisplaySublabel(user: CustomerComboboxUser): string | undefined {
  const label = getCustomerDisplayLabel(user);
  const name = getTrimmedValue(user.fullName ?? user.name);
  const email = getTrimmedValue(user.email);
  const parts = [name, email].filter(
    (part, index, all) => Boolean(part) && part !== label && all.indexOf(part) === index,
  );

  return parts.length > 0 ? parts.join(" · ") : undefined;
}

function getCustomerSearchText(user: CustomerComboboxUser): string | undefined {
  const parts = [
    getTrimmedValue(user.company),
    getTrimmedValue(user.fullName ?? user.name),
    getTrimmedValue(user.email),
  ].filter((part, index, all) => Boolean(part) && all.indexOf(part) === index);

  return parts.length > 0 ? parts.join(" ") : undefined;
}

export function buildCustomerComboboxOptions(
  users: readonly CustomerComboboxUser[] | undefined,
): ComboboxOption[] {
  if (!users) return [];

  return users.map((user) => ({
    value: user._id,
    label: getCustomerDisplayLabel(user),
    sublabel: getCustomerDisplaySublabel(user),
    searchText: getCustomerSearchText(user),
  }));
}
